var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LabelMedium, LabelExtraLarge } from '../../../labels';
import { OverlayTableStyle } from './OverlayTableStyle';
export var SimpleOverlayTable = function (_a) {
    var prettyEstimates = _a.prettyEstimates, mileageTitle = _a.mileageTitle, costTitle = _a.costTitle, props = __rest(_a, ["prettyEstimates", "mileageTitle", "costTitle"]);
    return (_jsx(OverlayTableStyle, __assign({ className: props.className, id: props.id }, { children: _jsxs("div", __assign({ className: "table-wrapper" }, { children: [_jsxs("div", __assign({ className: "title-wrapper" }, { children: [_jsx(LabelMedium, __assign({ className: "column-title" }, { children: mileageTitle })), _jsx(LabelMedium, __assign({ className: "column-title cost" }, { children: costTitle }))] })), prettyEstimates.map(function (item) {
                    return item.active ? (_jsxs("div", __assign({ className: "item-row active" }, { children: [_jsx(LabelExtraLarge, __assign({ className: "item-active" }, { children: item.estimateMiles })), _jsx(LabelExtraLarge, __assign({ className: "item-active" }, { children: "\u00A3".concat(item.estimateCost) }))] }))) : (_jsxs("div", __assign({ className: "item-row" }, { children: [_jsx(LabelMedium, __assign({ className: "item" }, { children: item.estimateMiles })), _jsx(LabelMedium, __assign({ className: "item" }, { children: "\u00A3".concat(item.estimateCost) }))] })));
                })] })) })));
};
